import { useEffect, useRef } from "react";
import { api, wsUrl } from "@/lib/api";

/** Joins a realtime room via the ticket flow. Reconnects with backoff. */
export function useRoom(room, onEvent) {
  const handler = useRef(onEvent);
  handler.current = onEvent;

  useEffect(() => {
    if (!room) return;
    let ws = null;
    let closed = false;
    let attempt = 0;
    let timer = null;

    const connect = async () => {
      try {
        const { ticket } = await api("/auth/ws-ticket", { method: "POST" });
        if (closed) return;
        ws = new WebSocket(wsUrl(room, ticket));
        ws.onopen = () => {
          attempt = 0;
        };
        ws.onmessage = (msg) => {
          try {
            handler.current(JSON.parse(String(msg.data)));
          } catch {
            /* ignore */
          }
        };
        ws.onclose = (ev) => {
          if (closed || ev.code === 4401 || ev.code === 4403) return;
          attempt += 1;
          timer = setTimeout(connect, Math.min(15000, 1000 * 2 ** attempt));
        };
        ws.onerror = () => ws?.close();
      } catch {
        if (closed) return;
        attempt += 1;
        timer = setTimeout(connect, Math.min(15000, 1000 * 2 ** attempt));
      }
    };
    connect();
    const ping = setInterval(() => ws?.readyState === 1 && ws.send("ping"), 25000);

    return () => {
      closed = true;
      clearInterval(ping);
      if (timer) clearTimeout(timer);
      ws?.close();
    };
  }, [room]);
}
